'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _formRow = require('../../WebformElement/styled/form-row');

var _formRow2 = _interopRequireDefault(_formRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.fieldset.withConfig({
  componentId: 'wdz3s4-0'
})(['box-sizing:border-box;margin-bottom:calc(', ' * 1.5);border:', ';border-radius:', ';background-color:', ';padding:calc(', ' * 1) calc(', ' * 1);@media screen and (min-width:768px){padding:calc(', ' * 2.5) calc(', ' * 2.5);}&', '{border:none;}'], function (p) {
  return p.theme.spacingUnitFieldset;
}, function (p) {
  return p.theme.fieldsetBorder;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.fieldsetBgColor;
}, function (p) {
  return p.theme.spacingUnitFieldset;
}, function (p) {
  return p.theme.spacingUnitFieldset;
}, function (p) {
  return p.theme.spacingUnitFieldset;
}, function (p) {
  return p.theme.spacingUnitFieldset;
}, _formRow2.default);